<template>
  <div>
    <Row>
      <Col offset="1" span="21">
      <Row type="flex" justify="center">
        <Col v-for="row in columns" :key="row.title">
          <Tooltip transfer :content="row.title" :delay="500">
            <Button class="demo" :style="{color:row.color}" @click="myclick">
                {{row.data}}
              </Button>
          </Tooltip>
        </Col>
      </Row>
      </Col>
      <Col span="2">
          <Tooltip transfer content="修改" :delay="1500">
            <Button class="demo" icon="md-settings" style="font-size:20px" @click="myclick"/>
          </Tooltip>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "render_table_view",
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  methods:{
      myclick() {
        this.$emit("myclick", 1);
      }
    }
};
</script>
<style>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>
